import getCookie from "components/LanguageProvider/utils/cookies";
import safely from "utils/safeCookie";
// Shared by hooks/useCookieConsent (typed React state) and hasAnalyticsConsent below
// (plain function for call sites outside a component tree, e.g. utils/UTM.ts) so the
// cookieyes-consent cookie format is only parsed in one place.
export const parseConsentCookie = (cookieStr) => {
    const entries = cookieStr.split(",").map((pair) => pair.split(":"));
    const result = {};
    entries.forEach(([key, value]) => {
        if (key && value) {
            result[key.trim()] = value.trim();
        }
    });
    return result;
};
// Standalone (non-hook) analytics consent check for call sites outside a component tree
// (e.g. utils/UTM.ts), mirroring the default-deny-for-UK/EU logic in hooks/useCookieConsent.
export const hasAnalyticsConsent = () => {
    var _a;
    const cookie = safely(() => getCookie("cookieyes-consent"), null);
    if (!cookie) {
        return !((_a = window.Chuffed) === null || _a === void 0 ? void 0 : _a.isUkOrEu);
    }
    return parseConsentCookie(cookie).analytics === "yes";
};
